import { render, staticRenderFns } from "./WaGroupDetail.vue?vue&type=template&id=842b9bc4&scoped=true"
import script from "./WaGroupDetail.vue?vue&type=script&lang=js"
export * from "./WaGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./WaGroupDetail.vue?vue&type=style&index=0&id=842b9bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842b9bc4",
  null
  
)

export default component.exports